// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"127":"44d65971","208":"d7943eda","245":"ff3d9502","821":"50aa7491"}[chunkId] + ".js";
};